/* eslint-disable */
import Vue from "vue";
import Vuex from "vuex";
import { ui } from "./ui/index";
import { user } from "@/store/user";
import { evaluation } from "@/store/evaluation";
import { toast } from "@/store/toast";
import { IState } from "@/interfaces/IState";
import VuexPersistence from 'vuex-persist'
import { pdf } from "./pdf";
import {timer} from "./timer";

Vue.use(Vuex);

export default new Vuex.Store<IState>({
    modules: {
        ui,
        user,
        evaluation,
        toast,
        pdf,
        timer
    },
    plugins: [new VuexPersistence().plugin]
});
